import React, { useEffect, useState } from 'react';
import { Alert, Button, MenuItem, Stack, TextField } from '@mui/material';
import { UNLISTED, errorText, settingsBody, settingsToForm } from './policyEdit';

// The account-wide settings: what to do about software the policy does not mention.
function SettingsTab({ account, data, canEdit, onSave }) {
  const [form, setForm] = useState(settingsToForm(data?.settings));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => { setForm(settingsToForm(data?.settings)); setSaved(false); }, [data]);

  const save = async () => {
    setSaving(true);
    setError('');
    setSaved(false);
    try {
      await onSave(settingsBody(account, form));
      setSaved(true);
    } catch (ex) {
      setError(errorText(ex));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Stack spacing={2} sx={{ maxWidth: 520 }}>
      <TextField select label="Software the policy does not mention" value={form.unlistedSoftware} disabled={!canEdit}
        onChange={(e) => setForm({ ...form, unlistedSoftware: e.target.value })}
        helperText="Ignore it (the usual choice), or report it as a finding.">
        {UNLISTED.map((u) => <MenuItem key={u.value} value={u.value}>{u.label}</MenuItem>)}
      </TextField>
      {error && <Alert severity="error">{error}</Alert>}
      {saved && <Alert severity="success">Saved.</Alert>}
      <Stack direction="row"><Button variant="contained" onClick={save} disabled={!canEdit || saving}>Save settings</Button></Stack>
    </Stack>
  );
}

export default SettingsTab;
